import { isEqual, pick } from 'lodash'
import { useRef, useState } from 'react'

import { TUsePaginationParams } from './helpers/types'

interface PaginationValue<T> {
  selectedPage: number
  setSelectedPage(selected: number): void
  goToFirstPage(): void
  paginatedElements: T[]
  pageCount: number
}

export const usePagination = <T>({
  pageSize,
  elements = [],
}: TUsePaginationParams<T>): PaginationValue<T> => {
  const [selectedPage, setSelectedPage] = useState(0)
  const goToFirstPage = () => setSelectedPage(0)

  const ref = useRef<PaginationValue<T>>(undefined)

  const offset = pageSize * selectedPage

  const value = {
    selectedPage,
    setSelectedPage,
    goToFirstPage,
    paginatedElements: elements.slice(offset, offset + pageSize),
    pageCount: Math.ceil(elements.length / pageSize),
  }

  const prev = pick(ref.current, [
    'selectedPage',
    'paginatedElements',
    'pageCount',
  ])
  const curr = pick(value, ['selectedPage', 'paginatedElements', 'pageCount'])

  if (!ref.current || !isEqual(prev, curr)) {
    ref.current = value

    return value
  }

  return ref.current
}
